<template>
  <div id="contenedor-registrar-usuario-contratista">
    <v-form ref="formRegistrarUsuarioContratista">
      <v-row>
        <CustomAutocomplete
          v-model="usuario.idContratista"
          label="Contratista"
          :items="getListadoContratistas"
          itemText="nombreRazonSocial"
          itemValue="id"
          clearable
          :rules="[mixReglas.requerido]"
          cols="12">
        </CustomAutocomplete>
        <v-col cols="12">
          <CustomTextField
            v-model="usuario.correoElectronico"
            label="Correo"
            :rules="[mixReglas.requerido, mixReglas.email]">
          </CustomTextField>
        </v-col>
        <v-col>
          <CustomTextField
            v-model="usuario.password"
            label="Password"
            type="password"
            :rules="[mixReglas.requerido]">
          </CustomTextField>
        </v-col>
        <v-col>
          <CustomTextField
            v-model="usuario.rePassword"
            label="Re-Password"
            type="password"
            :rules="[mixReglas.requerido]">
          </CustomTextField>
        </v-col>
      </v-row>
      <!-- <v-btn @click="registrar">Registrar</v-btn> -->
    </v-form>
  </div>
</template>

<script>
import USUARIOS from '@/graphql/querys/administracion/catalogos/usuarios/usuarios.gql';
import AGREGAR_USUARIO from '@/graphql/mutations/administracion/catalogos/usuarios/agregarUsuario.gql';
import CONTRATISTAS from '@/graphql/querys/administracion/catalogos/contratistas/contratistas.gql';
import CustomAutocomplete from '@/components/inputs/Autocomplete.vue';
import CustomTextField from '@/components/inputs/sinColumnas/TextField.vue';

export default {
  name: 'RegistrarUsuarioContratista',
  components: {
    CustomAutocomplete,
    CustomTextField,
  },
  data() {
    return {
      usuario: {
        idFuncionario: null,
        idContratista: null,
        correoElectronico: null,
        avatarPublicKey: null,
        password: '',
        rePassword: '',
        roles: ['CONTRATISTA:SUPERVISION'],
        scopes: [],
      },
    };
  },
  apollo: {
    contratistas: {
      query: CONTRATISTAS,
    },
  },
  methods: {
    async registrar() {
      await this.$apollo
        .mutate({
          mutation: AGREGAR_USUARIO,
          variables: { usuario: this.usuario },
          update: (cache, { data: { agregarUsuario } }) => {
            const data = cache.readQuery({ query: USUARIOS });
            data.usuarios.push(agregarUsuario);
            cache.writeQuery({ query: USUARIOS, data });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });
      this.cerrar();
    },
    cerrar() {
      this.$refs.formRegistrarUsuarioContratista.reset();
      this.$emit('cerrar');
    },
  },
  computed: {
    getListadoContratistas() {
      if (!this.contratistas) return [];

      return this.contratistas;
    },
  },
};
</script>

<style lang="scss">

</style>
